import { render, staticRenderFns } from "./record-query.vue?vue&type=template&id=2cb96e16"
import script from "./record-query.vue?vue&type=script&lang=ts"
export * from "./record-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports